import { useCallback } from 'react';
import Countdown, { zeroPad } from 'react-countdown';
import useTranslation from 'next-translate/useTranslation';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Modal, OwnPhoneInput } from '@/components/ui';
import { ArrowRight } from '@/components/SvgComponents';
import {
  selectors as orderSelectors,
  actions as orderActions,
} from '@/domains/esim/order';

import styles from '../../Checkout/Checkout.module.scss';

const OtpEsim = ({ modalProps, formikProps, otpProps, handleApprove }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { active, setActive } = modalProps;
  const { formikMain, formikPhone } = formikProps;
  const { timer, finish, setFinish, wrongOtp, expired } = otpProps;
  const { disabled } = useSelector(orderSelectors.selectOrder);

  const Completionist = () => <div>00:00</div>;

  const renderer = useCallback(({ minutes, seconds, completed }) => {
    if (completed) {
      setFinish(true);
      return <Completionist />;
    }
    return (
      <div>
        {zeroPad(minutes)}:{zeroPad(seconds)}
      </div>
    );
  }, []);

  const Counter = useCallback(() => {
    return <Countdown date={timer} renderer={renderer} />;
  }, [renderer, timer]);

  return (
    <Modal
      active={active}
      setActive={() => {
        setActive(!active);
        dispatch(orderActions.setDisabled(!disabled));
      }}
      itemScope
      itemType='https://schema.org/Property'
      closeOnOutsideClick={false}
    >
      {!formikPhone?.values?.error && (
        <>
          <strong className={'title'}>{t('esim:common.otp')}</strong>
          <div className={styles.modalPanel}>
            <strong>
              {`+994 (${formikMain.values.phoneNumberCode.name?.slice(-2)}) ${
                formikMain.values.phoneNumber
              }`}
            </strong>
          </div>
          <form
            className={styles.optInputContainer}
            onSubmit={formikPhone.handleSubmit}
          >
            <OwnPhoneInput
              inputClass={styles.optInput}
              value={formikPhone.values.code}
              separationPoints={[]}
              className={styles.opt}
              placeholder={''}
              onChange={(value) => formikPhone.setFieldValue('code', value)}
            />
            <div className={styles.text}>
              <p className={classNames({ disabled_otp_wrapper: !finish })}>
                {t('esim:checkout.inputs.receiveOtp')}
                <span
                  className={classNames(styles.resend, {
                    'active-otp': finish,
                    'disabled-otp': !finish,
                  })}
                  onClick={handleApprove}
                >
                  {t('esim:checkout.actions.resend')}
                </span>
              </p>

              {active && <Counter />}
            </div>
            {wrongOtp && (
              <p className={styles.wrong_otp}> {t('esim:common.wrongOtp')}</p>
            )}
            {expired && (
              <p className={styles.wrong_otp}> {t('esim:common.attempt')}</p>
            )}
            <Button
              type={'submit'}
              disabled={!(formikPhone.isValid && formikPhone.dirty)}
              className={styles.button}
            >
              {t('esim:checkout.actions.continue')}
              <ArrowRight width={24} />
            </Button>
          </form>
        </>
      )}
    </Modal>
  );
};

export default OtpEsim;
